import { InboxIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import { SearchIcon } from "@heroicons/react/solid";

export function EmptyConversationStatus({
  setShowContactList,
}: {
  setShowContactList: () => void;
}) {
  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <div className="w-full h-full flex flex-col relative">
      <div className="sticky top-0 z-20 bg-white md:hidden flex flex-col gap-6 md:gap-[18px]">
        <h2 className="text-lg leading-6 font-medium text-gray-900">
          {t("messages")}
        </h2>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
            <SearchIcon className=" h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full ps-10 border border-gray-300 focus:ring-brandblue-500 focus:border-brandblue-500 text-sm rounded-md"
            placeholder={t("searchByName")}
          />
        </div>
      </div>
      <div className="w-full     h-screen flex flex-col text-center gap-4 justify-center items-center ">
        <div>
          <InboxIcon className="h-24  w-24  md:w-10 md:h-10 text-gray-400" />
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-gray-700  font-medium text-base">
            {t("emptyChats")}
          </h3>
          <p className="text-gray-300  font-medium text-sm">
            {t("selectContact")}
          </p>
        </div>
      </div>
      <div className="sticky z-[999] w-full bg-white bottom-0  flex justify-center items-center  md:hidden">
        <button
          type="button"
          className="text-gray-700 font-medium  flex justify-center items-center h-9 w-full py-2 text-sm bg-white border  border-gray-300 rounded-md shadow"
          onClick={() => setShowContactList()}
        >
          {t("viewContacts")}
        </button>
      </div>
    </div>
  );
}
